import { createPopoverProperty } from '@/lib/helpers/createPopoverProperty.tsx'
import { ParentT, PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'
import { ProjectStagesUsersT } from '@/components/common/menu/lib/types/projectStagesUsers.ts'
import Span from '@/components/common/textElements/Span'
import { formatUserName } from '@/lib/helpers/formatUserName.ts'

export default function createUsersProperties(
  users: ProjectStagesUsersT | undefined | null,
  parent?: ParentT,
) {
  const usersProperties: PopoverProperty[] =
    users?.map(user => {
      let userName = formatUserName(user)
      const labelNode = (
        <Span>
          {userName}{' '}
          {user.projectRole && user.projectOrganization && (
            <Span size={'xxs'} className={`user-organization-info block text-gray-500`}>
              ({user.projectRole}/{user.projectOrganization})
            </Span>
          )}
        </Span>
      )

      return createPopoverProperty({
        label: userName,
        value: user['@id'] as string,
        labelNode,
        parent,
      })
    }) ?? []

  return { usersProperties }
}
